const pageNameKey = "otaBackupStart";

export const otaBackupStartEn = {
  [pageNameKey]: {
    noBackupsAvailableText: "No backups available",
    createFirmwareBackup: "Create a backup of your firmware",
    createConfigurationBackup: "Create a backup of your configuration",
    createBackupText: "Create Backup",
  },
};

export const otaBackupStartPtBr = {
  [pageNameKey]: {
    noBackupsAvailableText: "Nenhum backup disponível",
    createFirmwareBackup: "Crie um backup do seu firmware",
    createConfigurationBackup: "Crie um backup da sua configuração",
    createBackupText: "Criar backup",
  },
};

export const otaBackupStartDe = {
  [pageNameKey]: {
    noBackupsAvailableText: "Keine Backups verfügbar",
    createFirmwareBackup: "Erstellen Sie ein Backup Ihrer Firmware",
    createConfigurationBackup: "Erstellen Sie ein Backup Ihrer Konfiguration",
    createBackupText: "Backup erstellen",
  },
};

export const otaBackupStartZhHans = {
  [pageNameKey]: {
    noBackupsAvailableText: "没有可用的备份",
    createFirmwareBackup: "创建您的固件备份",
    createConfigurationBackup: "创建您的配置备份",
    createBackupText: "创建备份",
  },
};

export const otaBackupStartIt = {
  [pageNameKey]: {
    noBackupsAvailableText: "Nessun backup disponibile",
    createFirmwareBackup: "Crea un backup del tuo firmware",
    createConfigurationBackup: "Crea un backup della tua configurazione",
    createBackupText: "Crea backup",
  },
};

export const otaBackupStartEs = {
  [pageNameKey]: {
    noBackupsAvailableText: "No hay copias de seguridad disponibles",
    createFirmwareBackup: "Crea una copia de seguridad de tu firmware",
    createConfigurationBackup:
      "Crea una copia de seguridad de tu configuración",
    createBackupText: "Crear copia de seguridad",
  },
};

export const otaBackupStartNl = {
  [pageNameKey]: {
    createBackupText: "Back-up maken",
    createConfigurationBackup: "Maak een back-up van uw configuratie",
    createFirmwareBackup: "Maak een back-up van uw firmware",
    noBackupsAvailableText: "Geen back-ups beschikbaar",
  },
};

export const otaBackupStartTr = {
  [pageNameKey]: {
    createBackupText: "Yedekleme Oluştur",
    createConfigurationBackup: "Yapılandırmanızın bir yedeğini oluşturun",
    createFirmwareBackup: "Firmware'inizin bir yedeğini oluşturun",
    noBackupsAvailableText: "Yedekleme yok",
  },
};
